import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';

/**
 * 投关活动模块标签页的选项计算
 */
export function useInvestmentActivityTabs() {
	const { config, loadModuleConfig } = useModuleConfig();
	const { roadshow, offline, research } = useModuleData();

	// 1. 获取模块配置
	const getModuleTabConfig = async () => {
		await loadModuleConfig('investment_activity');
		const tabData = config.value?.tab || [];

		if (!tabData.length) {
			return [];
		}

		// 过滤和排序
		return tabData.filter(v => v.isPublish).sort((a, b) => a.sort - b.sort);
	};

	

	// 2. 格式化标签选项
	const formatTabOptions = tabs => {
		return tabs.map(item => ({
			label: item.name,
			value: item.id
		}));
	};

	// 3. 组合方法：完整的标签页选项计算
	const getAvailableTabs = async () => {
		let tabConfig = await getModuleTabConfig();
		return formatTabOptions(tabConfig);
	};

	return {
		getAvailableTabs
	};
}
